import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5 my-10" }, "Dados bancários", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5 my-10" }, "Observações", -1)

import AppTemplate from '@/app/shared/ui/templates/AppTemplate.vue';
import { ref, reactive, inject } from 'vue';
import rules from '@/app/shared/domain/data/rules';
import InputAvatar from '@/app/shared/components/inputs/InputAvatar.vue';
import Provider from '@/app/provider/domain/interfaces/Provider';
import InputCostCenter from '@/app/shared/components/inputs/InputCostCenter.vue';
import InputAddress from '@/app/shared/components/inputs/InputAddress.vue';
import InputBankAccount from '@/app/shared/components/inputs/InputBankAccount.vue';
import ProviderRepository from '@/app/provider/infrastructure/persistence/ProviderRepository';
import InputDocument from '@/app/shared/components/inputs/InputDocument.vue';
import Tabs from '@/app/shared/components/Tabs.vue';
import { useForm } from '@/app/shared/ui/composable/form';
import CnpjData from '@/app/shared/domain/classes/CnpjData';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderForm',
  props: ['id'],
  setup(__props) {

const props = __props;

const repository = inject('providerRepository') as ProviderRepository;

const picture = ref(null);
const form = ref(null);

let provider = reactive({
    image: 'default.jpg',
} as Provider);

const { pageTitle, submitAttach } = useForm(
    props,
    provider,
    repository,
    form,
    'Editar fornecedor',
    'Cadastrar fornecedor',
    '/fornecedores',
    '/fornecedores',
);

function submit() {
    submitAttach(picture.value);
}

const tabItens = [
    {
        icon: 'mdi:mdi-book-open',
        key: 'main',
        title: 'Principal'
    },
    {
        icon: 'mdi:mdi-map-marker',
        key: 'address',
        title: 'Endereço'
    },
    {
        icon: 'mdi:mdi-plus-circle-outline',
        key: 'add',
        title: 'Adicionais'
    },
];

function cnpjDataFound(data: CnpjData) {
    provider.name = data.name;
    provider.email = data.email;
    provider.phone = data.phone;
    provider.address = {
        zip_code: data.zipCode,
        street: data.street,
        number: data.number,
        complement: data.complement ?? '',
        neighborhood: data.neighborhood,
        city: data.city,
        state: data.state,
    };
}

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createBlock(AppTemplate, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "space-around" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { width: "100%" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_toolbar, { color: "surface" }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: submit,
                    "prepend-icon": "mdi:mdi-content-save",
                    color: "primary",
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Salvar")
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar_title, { class: "text-h6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(pageTitle)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    "lazy-validation": "",
                    ref_key: "form",
                    ref: form
                  }, {
                    default: _withCtx(() => [
                      _createVNode(Tabs, { itens: tabItens }, {
                        main: _withCtx(() => [
                          _createVNode(_component_v_row, { wrap: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                lg: "2",
                                align: "center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(InputAvatar, {
                                    "image-path": "providers",
                                    src: _unref(provider).image,
                                    modelValue: picture.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((picture).value = $event))
                                  }, null, 8, ["src", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                lg: "10"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(InputDocument, {
                                        modelValue: _unref(provider).document,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(provider).document) = $event)),
                                        onCnpjDataFound: cnpjDataFound
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            rules: [_unref(rules).required],
                                            label: "Nome",
                                            modelValue: _unref(provider).name,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(provider).name) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            label: "Email",
                                            rules: [_unref(rules).email, _unref(rules).required],
                                            modelValue: _unref(provider).email,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(provider).email) = $event))
                                          }, null, 8, ["rules", "modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Telefone",
                                            rules: [_unref(rules).phone],
                                            modelValue: _unref(provider).phone,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(provider).phone) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '(##)####-####']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_v_text_field, {
                                            label: "Celular / Whatsapp",
                                            rules: [_unref(rules).phone],
                                            modelValue: _unref(provider).cell_phone,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(provider).cell_phone) = $event))
                                          }, null, 8, ["rules", "modelValue"]), [
                                            [_directive_mask, '(##)#####-####']
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        sm: "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(InputCostCenter, {
                                            modelValue: _unref(provider).cost_center_id,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(provider).cost_center_id) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        address: _withCtx(() => [
                          _createVNode(InputAddress, {
                            modelValue: _unref(provider).address,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(provider).address) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        add: _withCtx(() => [
                          _hoisted_1,
                          _createVNode(InputBankAccount, {
                            modelValue: _unref(provider).account,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(provider).account) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_v_divider),
                          _hoisted_2,
                          _createVNode(_component_v_text_field, {
                            label: "Observações",
                            modelValue: _unref(provider).observations,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(provider).observations) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})